export default class LinkUtil {

    static openNewTab(link: string) {
        window.open(link, "_blank")
    }

    static open(link: string) {
        window.location.href = link
    }

    // static email(to: string, subject: string = "") {
    //     var link = "mailto:" + encodeURIComponent(to)
    //     if (isEmpty(subject)) {
    //         link += "?subject=" + encodeURIComponent(subject)
    //     }
    //     this.open(link)
    // }

    static phone(to: string) {
        this.open("tel:" + to)
    }

}